import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { User } from 'src/app/_models/user';
import { CustomerService } from 'src/app/_services/customer.service';

@Component({
    selector: 'app-thankyou',
    templateUrl: './thankyou.component.html',
    styleUrls: ['./thankyou.component.css'],
    standalone: false
})
export class ThankyouComponent implements OnInit {

  user : User;
  constructor(public customerService: CustomerService) { }

  ngOnInit(): void {

    this.customerService.currentTempUser$.pipe(take(1)).subscribe(user => this.user = user);

  }

}
